module.exports = __webpack_public_path__ + "img/icon_heart.ad1804ff.svg";